import { makeAutoObservable, runInAction, toJS } from "mobx";
import ApiData from "./ApiData";
import Memory from "./Memory";
import stateFilter from "../state/state.filter";
import { normalizeSubscriptionMaxPeriod } from "../utils/reportManagerFilterUtils";
import { compareSoftVersionForReport } from "../utils/softVersionCompareUtils";
import {
  getSoftwareTypeFromSession,
  matchesSoftwareTypeMode,
} from "../utils/softVersionClientTypeUtils";

class funcFilter {
  license = ""; // Лицензия для активации клиента
  license_index = 0; // Лицензия для активации клиента
  base_clients_soft = null;

  constructor() {
    makeAutoObservable(this);
  }

  setParameters = (name, value) => {
    this[name] = value;
  };
  // Cортировка версии софта на увеличение
  sortFuncSoftVersionAB(arr) {
    arr.sort((a, b) => {
      if (a.software_version < b.software_version) {
        return -1;
      }
      if (a.software_version > b.software_version) {
        return 1;
      }
      return 0;
    });
  }
  // Cортировка версии софта на уменьшение
  sortFuncSoftVersionBA(arr) {
    arr.sort((a, b) => {
      if (a.software_version < b.software_version) {
        return 1;
      }
      if (a.software_version > b.software_version) {
        return -1;
      }
      return 0;
    });
  }
  // Cортировка по наименованию софта на увеличение
  sortFuncSoftNameAB(arr) {
    arr.sort((a, b) => {
      if (a["software_client_rel"].name < b["software_client_rel"].name) {
        return -1;
      }
      if (a["software_client_rel"].name > b["software_client_rel"].name) {
        return 1;
      }
      return 0;
    });
  }
  // Cортировка по наименованию софта на уменьшение
  sortFuncSoftNameBA(arr) {
    arr.sort((a, b) => {
      if (a["software_client_rel"].name < b["software_client_rel"].name) {
        return 1;
      }
      if (a["software_client_rel"].name > b["software_client_rel"].name) {
        return -1;
      }
      return 0;
    });
  }
  // // Cортировка по дате сгорания лицензии на увеличение
  // sortFuncActivDataAB(arr) {
  //   arr.sort((a, b) => {
  //     if (a.activ_data < b.activ_data) {
  //       return -1;
  //     }
  //     if (a.activ_data > b.activ_data) {
  //       return 1;
  //     }
  //     return 0;
  //   });
  // }
  // // Cортировка по дате сгорания лицензии на уменьшение
  // sortFuncActivDataBA(arr) {
  //   arr.sort((a, b) => {
  //     if (a.activ_data < b.activ_data) {
  //       return 1;
  //     }
  //     if (a.activ_data > b.activ_data) {
  //       return -1;
  //     }
  //     return 0;
  //   });
  // }
  // Cортировка cроку жизни лицензии (в днях) лицензии на увеличение
  sortFuncvalidPeriodDaysAB(arr) {
    arr.sort((a, b) => {
      if (a.valid_period_days < b.valid_period_days) {
        return -1;
      }
      if (a.valid_period_days > b.valid_period_days) {
        return 1;
      }
      return 0;
    });
  }
  // Cортировка cроку жизни лицензии (в днях) лицензии на увеличение
  sortFuncvalidPeriodDaysBA(arr) {
    arr.sort((a, b) => {
      if (a.valid_period_days < b.valid_period_days) {
        return 1;
      }
      if (a.valid_period_days > b.valid_period_days) {
        return -1;
      }
      return 0;
    });
  }
  //   Сортировка последняя сессия увеличение
  sortFuncLastSessionAB(arr) {
    arr.sort((a, b) => {
      let aa = new Date(a.last_session).getTime();
      let bb = new Date(b.last_session).getTime();
      return aa - bb;
    });
  }
  //   Сортировка последняя сессия уменьшение
  sortFuncLastSessionBA(arr) {
    arr.sort((a, b) => {
      let aa = new Date(a.last_session).getTime();
      let bb = new Date(b.last_session).getTime();
      return bb - aa;
    });
  }
  // Cортировка по площадкам
  sortSoftProduction = async (id) => {
    ApiData.observableSoft = true;
    ApiData.company.clients_soft = ApiData.company.clients_soft_data.filter(
      (cs) => cs["production_rel"] !== null && cs["production_rel"].id === id,
    );
    Memory.funcFilterByProduction(
      ApiData.company.this_production.name_production,
    );
    ApiData.observableSoft = false;
  };
  // Cортировка по клиентам не привязанных к площадкам
  sortSoftProductionNull = () => {
    if (ApiData.company.clients_soft_data === null) return;
    runInAction(() => {
      ApiData.company.clients_soft = ApiData.company.clients_soft_data.filter(
        (cs) => cs["production_rel"] === null,
      );
    });
    Memory.funcFilterByProduction("Без площадки");
  };
  // Отобразить всех клиентов
  showAllClients = async () => {
    if (ApiData.company.clients_soft_data === null) return false;
    runInAction(() => {
      ApiData.company.clients_soft = [...ApiData.company.clients_soft_data];
    });
    Memory.funcFilterByProduction(null);
    this.dayFilterLic();
    return true;
  };
  // Выбранная лицензия
  selectlicense() {
    if (ApiData.company.licensing_free.length) {
      this.license = ApiData.company.licensing_free[this.license_index];
    }
    Memory.funcFilterByProduction(null);
  }

  // Фильтр по id client card company
  searchIdClient = (search) => {
    if (search.length >= 2) {
      return (ApiData.company.clients_soft =
        ApiData.company.clients_soft.filter((clid) =>
          toJS(clid).client_id.toLowerCase().includes(search.toLowerCase()),
        ));
    }
    return (ApiData.company.clients_soft = ApiData.company.clients_soft_data);
  };
  // Фильтр по id client весь софт
  searchIdClientAllSoft = (search) => {
    if (search) {
      return (ApiData.soft_all = ApiData.soft_all.filter((clid) =>
        toJS(clid).client_id.toLowerCase().includes(search.toLowerCase()),
      ));
    }
    runInAction(() => {
      ApiData.soft_all = ApiData.soft_all_data;
    });
  };

  // Функция выбора лицензии из списка

  selectFreeLic = (e) => {
    const freeID = ApiData.company.licensing_free.find(
      (l) => l.id_license === e.id_license,
    );
    if (freeID) {
      this.license = freeID;
    } else {
      const licClientID = ApiData.company.licensing.find(
        (l) => l.id_license === e.id_license,
      );
      if (licClientID) {
        this.license = licClientID;
      }
    }
  };
  // Фильтр по лицензиям, активация которых истекает через n дней
  dayFilterLic = () => {
    if (sessionStorage.getItem("day_active_flag") === "true") {
      ApiData.company.clients_soft = ApiData.company.clients_soft_data.filter(
        (lic) =>
          (lic.valid_period_days < Number(Memory.day_active_lic) &&
            lic.valid_period_days !== "" &&
            lic.valid_period_days !== null) ||
          lic.valid_period_days === "Истекла" ||
          lic.valid_period_days === "Обновите",
      );
    }
  };
  // Фильтр по компаниям общий
  filterDataCompanyReport = (search) => {
    if (search) {
      return (ApiData.subscription = ApiData.subscription_data.filter(
        (c) =>
          toJS(c)
            .company_rel.inn.toLowerCase()
            .includes(search.toLowerCase()) ||
          c.company_rel.name_company
            .toLowerCase()
            .includes(search.toLowerCase()),
      ));
    }
    return ApiData.subscription_data;
  };
  // Фильтр по версии софта в компании
  filterSoftVersionCompany = (version) => {
    if (ApiData.company.clients_soft_data === null) return;

    if (!version) {
      runInAction(() => {
        ApiData.company.clients_soft = [...ApiData.company.clients_soft_data];
      });
      this.dayFilterLic();
      return;
    }

    const threshold = String(version).trim();
    if (!threshold) {
      runInAction(() => {
        ApiData.company.clients_soft = [...ApiData.company.clients_soft_data];
      });
      this.dayFilterLic();
      return;
    }

    const mode = Memory.version_reduction;
    const softwareTypeMode = getSoftwareTypeFromSession();

    runInAction(() => {
      ApiData.company.clients_soft = ApiData.company.clients_soft_data.filter(
        (s) => {
          if (!s.software_version) return false;
          if (
            !compareSoftVersionForReport(
              s.software_version,
              threshold,
              mode,
            )
          ) {
            return false;
          }
          return matchesSoftwareTypeMode(s, softwareTypeMode);
        },
      );
    });
    this.dayFilterLic();
  };

  // Cортировка cроку жизни лицензии (в днях) лицензии на увеличение
  sortAllAB(arr, name) {
    return [...arr].sort((a, b) => {
      if (a[`${name}`] < b[`${name}`]) {
        return 1;
      }
      if (a[`${name}`] > b[`${name}`]) {
        return -1;
      }
      return 0;
    });
  }

  sortAllBA(arr, name) {
    return [...arr].sort((a, b) => {
      if (a[`${name}`] < b[`${name}`]) {
        return -1;
      }
      if (a[`${name}`] > b[`${name}`]) {
        return 1;
      }
      return 0;
    });
  }

  filterReportSubscription = async (max) => {
    try {
      const maxPeriod = normalizeSubscriptionMaxPeriod(max);
      if (stateFilter.subscription_companies) {
        const resSubMax = await ApiData.allReportSubscription(
          `subscription/valid_subscription?min_period=${ApiData.min_subscription}&max_period=${maxPeriod}&size=${ApiData.sizeItem}`,
        );
        return resSubMax;
      } else {
        const resSubMax = await ApiData.allReportSubscription(
          `subscription/valid_subscription?max_period=${maxPeriod}&size=${ApiData.sizeItem}`,
        );
        if (!Array.isArray(resSubMax)) {
          return resSubMax;
        }
        if (ApiData.companys === null) {
          await ApiData.getDataCompanys();
        }
        ApiData.companys.forEach((c) => {
          if (c.subscription_rel.length === 0 || c.subscription_rel === null) {
            resSubMax.push({
              company_id: c.id,
              company_rel: {
                inn: c.inn,
                name_company: c.name_company,
              },
              validity_date: null,
            });
          }
        });
        console.log("!resSubMax", resSubMax);
        ApiData.setParameters("subscription", resSubMax);
        return resSubMax;
      }
    } catch (e) {
      console.error(e);
    }
  };
}

export default new funcFilter();
